// 优惠券卡片动画配置
export const couponCardConfig = {
  initial: ({ couponMarginTop }: { couponMarginTop: number }) => {
    return {
      y: `calc(50vh + ${couponMarginTop}px)`,
      rotateY: 180,
      scale: 0.5,
    };
  },
  show: {
    y: '0',
    scale: [0.5, 0.76, 1.24, 1.25, 0.95, 1.03, 0.99, 1],
    rotateY: 0,
    transition: {
      y: {
        duration: 0.75,
        ease: [0, 0, 0, 1],
      },
      scale: {
        duration: 1.5,
        times: [0, 0.16, 0.47, 0.5, 0.67, 0.78, 0.89, 1],
        ease: [
          [0.18, 0, 0.7, 1],
          [0.32, 0.4, 0.71, 0.89],
          [0.18, 0.0, 0.7, 1.0],
          [0.7, 0.0, 0.7, 1.0],
          [0.7, 0.0, 0.7, 1.0],
          [0.7, 0.0, 0.5, 1.0],
          [0.5, 0.0, 0.5, 1.0],
        ],
      },
      rotateY: {
        delay: 0.25,
        duration: 0.45,
        ease: [0.7, 0, 0.7, 1],
      },
    },
  },
  hidden: ({ productLocation }: { productLocation: { x: string; y: string } }) => {
    return {
      scale: 0,
      ...productLocation,
      transition: {
        scale: {
          duration: 0.35,
          ease: [0.32, 0, 0.7, 1],
        },
      },
    };
  },
};

// 背景动画配置
export const maskConfig = {
  initial: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      delay: 0.5,
      duration: 0.35,
      ease: [0.17, 0, 0.83, 1],
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.35,
      ease: [0.17, 0, 0.83, 1],
    },
  },
};

// 光晕动画配置
export const auraConfig = {
  initial: {
    opacity: 1,
    scale: 0,
  },
  show: {
    opacity: 0,
    scale: 20,
    transition: {
      delay: 0.75,
      opacity: {
        delay: 1.08,
        duration: 1,
        ease: 'easeInOut',
      },
      scale: {
        delay: 0.916,
        duration: 1,
        ease: 'easeInOut',
      },
    },
  },
  hidden: {},
};

// 父组件动画配置
export const parentConfig = {
  initial: {
    opacity: 0,
  },
  show: {
    opacity: 1,
    transition: {
      duration: 0.5,
      when: 'beforeChildren',
    },
  },
  hidden: {},
};
